import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { CartridgeBookingService } from '@markant-platform/cartridge/feature-booking';

@Injectable({
  providedIn: 'root',
})
export class ManagementViewBreadcrumbResolver {
  constructor(private readonly cartridgeBookingService: CartridgeBookingService) {}

  /**
   * Returns an Observable of Breadcrumb[] and always emits on language change to display the correct localized cartridge name
   */
  resolve(route: ActivatedRouteSnapshot): Observable<Breadcrumb[]> {
    const param = route.params['bookingId'];
    const additionalBreadcrumb = route.routeConfig?.data?.['subBreadcrumb'];

    const url = route.pathFromRoot
      .filter(({ url }) => url.length)
      .map(({ url }) => url.map(segment => segment.toString()).join('/'))
      .join('/');

    return this.cartridgeBookingService.getBookingById(param).pipe(
      map(bookingById => {
        return [
          {
            label: bookingById.cartridgeVariantName,
            url,
          },
        ].concat(additionalBreadcrumb ? [additionalBreadcrumb] : []);
      })
    );
  }
}
